export default __webpack_public_path__ + "static/media/home-bottom-curve.9e87923d.svg";